import React from 'react';
function BMRTable({ formula, bmr, Sedentary, Exercise1_3, Exercise4_5, DailyExercise, IntenseExercise, VeryIntenseExercise }) {
    return (
        <table >
            <thead>
                <tr>
                    <th >Total Daily Caloric Needs:</th>
                    <th >Calories (per day)</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Sedentary (little or no exercise)</td>
                    <td>{Sedentary}</td>
                </tr>
                <tr>
                    <td>Exercise 1-3 days per week</td>
                    <td>{Exercise1_3}</td>
                </tr>
                <tr>
                    <td>Exercise 4-5 days per week</td>
                    <td>{Exercise4_5}</td>
                </tr>
                <tr>
                    <td>Daily exercise or intense exercise 3-4 times per week</td>
                    <td>{DailyExercise}</td>
                </tr>
                <tr>
                    <td>Hard exercise or sports 6-7 days per week</td>
                    <td>{IntenseExercise}</td>
                </tr>
                <tr>
                    <td>Very intense exercise daily or physical job</td>
                    <td>{VeryIntenseExercise}</td>
                </tr>
            </tbody>
        </table>
    );
}
export default BMRTable;
